<template>
  <div
    style="position: relative;"
  >
    <loader
      v-if="showLoader"
      show
    />
    <image-field
      v-if="canShow"
      :src="srcVal"
      max-width="20"
      height="20"
      :class="getClasses()"
      contain
      @onClick="onClick"
    />
  </div>
</template>

<script>
import ImageField from '@/global/components/fields/ImageField.vue'
import Loader from '@/global/components/loader/Loader.vue'

export default {
  name: 'TableCellIcon',

  components: {
    Loader,
    ImageField
  },

  props: {
    cellData: {
      type: [Boolean, Number, String, Object, Array],
      default: null
    },
    config: {
      type: Object,
      default: () => ({})
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      srcVal: undefined
    }
  },

  computed: {
    showLoader () {
      const { showLoader } = this.config || {}
      return !!showLoader
    },
    canShow () {
      const { show } = this.config || {}
      if (typeof show === 'function') {
        return show({
          cellData: this.cellData,
          rowData: this.rowData
        })
      }
      return show === true || show === undefined
    },
    isDisabled () {
      const { disabled } = this.config || {}
      let disabledVal = disabled

      if (typeof disabledVal === 'function') {
        disabledVal = disabledVal({
          cellData: this.cellData,
          rowData: this.rowData
        })
      }
      return disabledVal
    }
  },

  watch: {
    cellData: {
      immediate: true,
      handler (val) {
        const { src } = this.config || {}

        if (src && typeof src === 'string') {
          this.srcVal = src
        }
        else if (typeof src === 'function') {
          this.srcVal = src({
            data: val,
            rowData: this.rowData,
            changeSrc: (src) => this.changeSrc(src)
          })
        }
      }
    }
  },

  methods: {
    onClick () {
      const { onClick } = this.config || {}

      if (typeof onClick === 'function' && !this.isDisabled) {
        onClick({
          data: this.cellData,
          rowData: this.rowData,
          changeSrc: (src) => this.changeSrc(src)
        })
      }
    },

    changeSrc (src) {
      if (src && typeof src === 'string') {
        this.srcVal = src
      }
    },

    getClasses () {
      const { disabled } = this.config || {}
      const classes = 'cell-icon'
      let disabledVal = disabled

      if (typeof disabledVal === 'function') {
        disabledVal = disabledVal({
          cellData: this.cellData,
          rowData: this.rowData
        })
      }

      if (!disabledVal) {
        return classes
      }

      return `${classes} cell-icon--disabled`
    }
  }
}
</script>

<style scoped>
.cell-icon {
  cursor: pointer;
}

.cell-icon--disabled {
  cursor: default;
}
</style>
